<template>
  <div class="stars" v-bind="$attrs">
    <span v-for="(star, index) in display_stars" :key="index" class="stars__item"
      :class="[`stars__item--fill-${star}`, `stars__item--${size}`]"></span>
  </div>
</template>

<script>
import { computed } from "vue";

export default {
  props: {
    stars: {
      type: [Number, String],
      default: 0
    },
    size: {
      type: String,
      default: "XS",
      validator: value => ["XS", "S", "M"].includes(value)
    }
  },
  setup(props) {
    const display_stars = computed(() => {
      const numericStarsNumber = Math.min(Math.max(parseFloat(props.stars), 0), 5);
      const fullStars = Math.floor(numericStarsNumber);
      const fractionalStar = Math.round((numericStarsNumber - fullStars) * 10);

      return [
        ...Array(fullStars).fill("100"),
        ...(fractionalStar ? [`${fractionalStar * 10}`] : []),
        ...Array(5 - fullStars - (fractionalStar ? 1 : 0)).fill("0")
      ];
    });

    return {
      display_stars
    };
  }
};
</script>

<style scoped lang="scss">
.stars {
  display: flex;
  align-items: center;

  &__item {
    $this: &;
    display: inline-block;
    background-image: url("https://jiffy.imgix.net/gen/star_sprite-v2.png?auto=format");
    background-repeat: no-repeat;

    &--XS {
      width: 12px;
      height: 12px;
      background-size: 154px 14px;
    }

    &--S {
      width: 16px;
      height: 16px;
      background-size: 220px 20px;
      margin-right: 1px;
    }

    &--M {
      width: 24px;
      height: 24px;
      background-size: 330px 30px;
    }

    // For backward compatibility
    &--partial {
      &#{$this}--XS {
        background-position: -70px -2px;
      }

      &#{$this}--S {
        background-position: -102px -3px;
      }

      &#{$this}--M {
        background-position: -154px -4px;
      }
    }

    &--empty {
      &#{$this}--XS {
        background-position: 0 -2px;
      }

      &#{$this}--S {
        background-position: -2px -3px;
      }

      &#{$this}--M {
        background-position: -4px -4px;
      }
    }

    &--full {
      &#{$this}--XS {
        background-position: -140px -2px;
      }

      &#{$this}--S {
        background-position: -202px -3px;
      }

      &#{$this}--M {
        background-position: -304px -4px;
      }
    }

    // ---

    @for $i from 0 through 10 {
      &--fill-#{$i * 10} {
        &#{$this}--XS {
          background-position: -#{$i * 14}px -2px;
        }

        &#{$this}--S {
          background-position: -#{$i * 20 + 2}px -3px;
        }

        &#{$this}--M {
          background-position: -#{$i * 30 + 4}px -4px;
        }
      }
    }
  }
}
</style>
